import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ImmomioIconName } from '@resident-nx/shared';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbInputDatepicker,
} from '@ng-bootstrap/ng-bootstrap';
import { IconWebComponent } from '@resident-nx/web/ui';
import { DateParserFormatter, DateStringAdapter } from '../../../services/date';
import { ReactiveFormsModule } from '@angular/forms';
import {
  injectNgControl,
  NoopValueAccessorDirective,
} from '../../../directives/form/noop-value-accessor';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'rs-web-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrl: './date-picker.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [NoopValueAccessorDirective],
  imports: [NgbInputDatepicker, IconWebComponent, ReactiveFormsModule, TranslatePipe],
  providers: [
    {
      provide: NgbDateAdapter,
      useClass: DateStringAdapter,
    },
    {
      provide: NgbDateParserFormatter,
      useClass: DateParserFormatter,
    },
  ],
})
export class DatePickerComponent {
  readonly ngControl = injectNgControl();
  /** Translation key rendered as the floating label and placeholder. Leave empty to render no floating label (e.g. when a visible label lives elsewhere in the page). */
  readonly label = input<string>('');
  /** id of an external element whose text names this input for assistive tech. Use when the field's label is visually separate from the picker (e.g. a heading above a list of questions). */
  readonly ariaLabelledby = input<string | null>(null);
  readonly minDate = input<NgbDateStruct | undefined>(undefined);
  readonly maxDate = input<NgbDateStruct | undefined>(undefined);
  protected readonly ImmomioIconName = ImmomioIconName;
}
